<section class="ba">
  <header class="ba__head">
    <h2 class="ba__title">Balances &amp; Accruals</h2>
    <p class="ba__sub">
      Your leave balances and the ledger behind them — every balance reconciles to the movements below.
    </p>
  </header>

  @if (loading()) {
    <div class="ba__state">Loading balances…</div>
  } @else {
    <div class="ba__cards">
      @for (b of balances(); track b.leaveTypeId) {
        <button
          type="button"
          class="ba-card"
          [class.ba-card--on]="selectedTypeId() === b.leaveTypeId"
          (click)="selectType(b.leaveTypeId)">
          <div class="ba-card__name">{{ b.leaveTypeName }}</div>
          <div class="ba-card__avail">{{ b.availableBalance.toFixed(2) }}</div>
          <div class="ba-card__avail-lbl">available</div>

          <div class="ba-card__row"><span>Accrued</span><span>{{ b.totalAllocated.toFixed(2) }}</span></div>
          <div class="ba-card__row"><span>Used</span><span>{{ b.totalUsed.toFixed(2) }}</span></div>
          <div class="ba-card__row"><span>Reserved</span><span>{{ b.reservedLeaves.toFixed(2) }}</span></div>
          @if (b.carriedForwardLeaves > 0) {
            <div class="ba-card__row"><span>Carried forward</span><span>{{ b.carriedForwardLeaves.toFixed(2) }}</span></div>
          }
          @if (projectedLoss(b) > 0) {
            <div class="ba-card__warn">{{ projectedLoss(b).toFixed(2) }} day(s) lapse at year end — no carry-forward</div>
          }
        </button>
      } @empty {
        <div class="ba__state">No leave balances to show.</div>
      }
    </div>

    <div class="ba__ledger">
      <div class="ba__ledger-head">
        <h3 class="ba__ledger-title">Ledger timeline</h3>
        @if (selectedTypeId()) {
          <span class="ba__chip">filtered to the selected type — tap its card again to clear</span>
        }
      </div>
      <ers-grid
        class="ba__grid"
        [columnDefs]="columnDefs"
        [rowData]="filteredLedger()"
        [gridOptions]="gridOptions"></ers-grid>
    </div>
  }
</section>
